import { createApp } from "vue";
import App from "./App.vue";
import OutsideClickDirective from "@/OutsideClickDirective";
import { WpApiMembers } from "@/types/WpApi";

declare let wpApiMembers: WpApiMembers;

const mountId = wpApiMembers.uuid;

createApp(App)
  .directive("click-outside", OutsideClickDirective)
  .mount(`#${mountId}`);
